import Logo from "../assets/logos/logo-colors-2.svg";

const Footer = () => {
  return (
    <footer className="bg-brandBlue container overflow-y-hidden px-[1.5rem] text-white font-outfit text-center py-4">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-2">
          <img
            src={Logo}
            alt="IGC Logo"
            className="transform w-[100px] h-[50px] scale-[5]"
          />
        </div>
        <span className="text-white text-sm md:text-base">
          All rights reserved &copy; {new Date().getFullYear()}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
